import { defineStore } from 'pinia'
import NavigationDataService from "@/services/NavigationDataService"

export const useConfigStore = defineStore('config', {
    state: () => ({
        slideViewActive: false,
        slideViewType: null,
        currentLayoutId: null,
        currentNavItem: null,
        slideLayoutId: null,
        parents: [],
        parentItems: [],
        isInProjectPages: false,
        projectPageLayoutId: null,
        projectRootLayoutId: null,
        projectRootPages: {
            "fi":  ["tutkimukset ja hankkeet"],
            "sv": ["undersökningar och projekt"],
            "en": ["research and projects"]
        }
    }),
    getters: {
        isSlideViewActive: (state) => state.slideViewActive,
        getSlideViewType: (state) => state.slideViewType,
        getCurrentLayoutId: (state) => state.currentLayoutId,
        getCurrentNavItem: (state) => state.currentNavItem,
        getParents: (state) => state.parents,
        getParentItems: (state) => state.parentItems,
        getSlideLayoutId: (state) => state.slideLayoutId,
        getProjectRootPages: (state) => state.projectRootPages,
        getProjectPageLayoutId: (state) => state.projectPageLayoutId,
        getIsInProjectPages: (state) => state.isInProjectPages,
        getProjectRootLayoutId: (state) => state.projectRootLayoutId
    },
    actions: {
        setSlideViewActive(payload) {
            this.slideViewActive = payload
        },
        setCurrentLayoutId(payload) {
            this.currentLayoutId = payload
            NavigationDataService.getLayoutId(payload)
                .then((response) => {
                    if (response.data !== "") this.currentNavItem = response.data
                })
                .catch(e => console.log(e.error))
        },
        setCurrentNavItem(payload) {
          this.currentNavItem = payload
        },
        addParent(payload) {
            this.parents.push(payload)
        },
        addParentItem(payload) {
            this.parentItems.push(payload)
        },
        setSlideViewType(payload) {
            this.slideViewType = payload
        },
        setSlideLayoutId(payload) {
            this.slideLayoutId = payload
        },
        setIsInProjectPages(payload) {
            this.isInProjectPages = payload
        },
        setProjectPageLayoutId(payload) {
            this.projectPageLayoutId = payload
        },
        setProjectRootLayoutId(payload) {
            this.projectRootLayoutId = payload
        }
    }
})